import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { resolveUrl } from '@apps/landing/src/app/shared/utils/resolve-url';
import { API_VERSIONS } from '@apps/landing/src/app/shared/utils/api-versions';
import { Observable } from 'rxjs';
import { IServiceModel } from '@apps/landing/src/app/modules/services/models/service.model';
import { ResponsePage } from '@apps/landing/src/app/core/models/response-page.model';

@Injectable({
  providedIn: 'root',
})
export class OurServicesService {
  private http = inject(HttpClient);
  private readonly BASE_URL = resolveUrl(API_VERSIONS.V5, 'service');

  getServices(start: number, length: number, search?: string): Observable<ResponsePage<IServiceModel>> {
    const headers = new HttpHeaders({
      'api-version': API_VERSIONS.V5,
    });

    const body: any = {
      start,
      length,
      search,
      additionalValues: {
        actual: true,
      },
    };

    return this.http.post<ResponsePage<IServiceModel>>(`${this.BASE_URL}/pages`, body, { headers });
  }
}
